<template>
  <main>
    <header>
      <i class="icon-close"></i>
      <h2>登录</h2>
      <p>还没有账号？立即<a>注册</a></p>
    </header>
    <ul>
      <li>
        <input type="tel" ref="phone" v-model="submit.phone" maxlength="11" placeholder="请输入手机号码"/>
        <button @click='sendSMS' v-show="type === 'code'">{{ countdown === null ? '获取验证码' : countdown+'s'}}</button>
      </li>
      <li v-show="type==='password'"><input v-model="submit.password" ref="password" type="password" placeholder="请输入密码" @keydown.enter="login"/></li>
      <li v-show="type==='code'">
        <input 
          ref="code"
          v-model="submit.code" 
          type="tel" maxlength="4" 
          @keydown.enter="login"
          placeholder="请输入验证码"/>
      </li>
    </ul>
    <button class="login" @click="login">登录</button>
    <p class="hint" @click="changeLoginType">使用{{ getType }}登录</p>
  </main>
</template>

<script>
import $strategy from '@assets/js/strategy';
import $user from '@api/user';
export default {
  data () {
    return {
      type: 'password', // code = 手机验证码 | password = 密码
      countdown: null,
      submit: {
        phone: null,
        password: null,
        code: null
      }
    }
  },
  computed: {
    getType () {
      const { type } = this;
      switch (type) {
        case 'code':
          return '密码';
        case 'password':
          return '验证码'
      }
      return type;
    }
  },
  created () {
    const { params } = this.$route;
    !!params.name && (this.to = params);
  },
  methods: {
    changeLoginType () {
      const { type } = this;
      const value = type === 'code' ? 'password' : 'code';
      this.type = value;
    },
    sendSMS () {
      const { phone } = this.submit;
      if ( this.countdown !== null ) { return; }
      if ( !$strategy.check(phone, 'isMobile') ) { 
        this.$toast('手机格式有误！'); 
        this.$refs.phone.select();
        return; 
      }
      this.startCountdown('countdown');
      $user.sendSMS(phone).catch(err => console.warn('err', err))
    },
    login () {
      const { phone, code, password } = this.submit;

      if ( !$strategy.check(phone, 'isMobile') ) { 
        this.$toast('手机格式有误！'); 
        this.$refs.phone.select();
        return; 
      }
      const { type } = this;
      if ( type === 'code' ) {
        if ( code.length !== 4 ) {
          this.$toast('验证码有误！');
          this.$refs.code.focus();
          return;
        }
      } else {
        if ( $strategy.check(password, 'isEmpty') ) {
          this.$toast('密码不能为空！');
          this.$refs.password.focus();
          return;
        }
      }

      let data = { phoneNumber: phone };
      type === 'password' ? data.password = password : data.phoneCode = code;
      $user.login(data).then(res => {
        // 登录成功
        const { error } = res
        if ( error ) { return; }
        this.updateUserInfo(res);
        this.$toast('登录成功!');
        const { to } = this;
        this.$router.push( to || { name: 'home' });
      })
    }
  }
}
</script>

<style scoped src="./login.css"></style>